import axios from "axios";
import ENDPOINT from "../../context/EndPoint";

// Soft-deletes a saved certificate template.
const DeleteCertificateTemplate = async ({ payload }) => {
  const formData = new FormData();
  formData.append("session", payload.session);
  formData.append("id", payload.id);

  const res = await axios.post(ENDPOINT + "admin-delete-certificate-template.php", formData, {
    headers: { "content-type": "multipart/form-data" },
  });
  return res ? res.data : null;
};

export default DeleteCertificateTemplate;
